import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { getRoleLabel } from '@/lib/utils/utils';
import { useTranslation } from 'react-i18next';

export const FORM_COLLABORATOR_EDIT_ID = 'form-collaborator-edit';

const HIDDEN_ROLES = ['user', 'guest'];

export default function FormCollaboratorEdit({ collaborator, onSubmit, roles = [] }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        role: '',
    });

    useEffect(() => {
        if (collaborator) {
            setFormData({
                first_name: collaborator.firstName || '',
                last_name: collaborator.lastName || '',
                email: collaborator.email || '',
                role: (typeof collaborator.role === 'string' ? collaborator.role : collaborator.role?.name) || '',
            });
        }
    }, [collaborator, roles]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const name = `${formData.first_name} ${formData.last_name}`;
        if (!name.trim() || !formData.email.trim()) return;
        onSubmit({ ...collaborator, ...formData });
    };

    return (
        <form
            id={FORM_COLLABORATOR_EDIT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-6 py-4 space-y-5"
        >
            <Field>
                <FieldLabel required>{t('account:prenom')}</FieldLabel>
                <Input
                    type="text"
                    placeholder={t('account:marie')}
                    value={formData.first_name}
                    onChange={(e) => handleChange('first_name', e.target.value)}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('account:nom2')}</FieldLabel>
                <Input
                    type="text"
                    placeholder="DUBOIS"
                    value={formData.last_name}
                    onChange={(e) => handleChange('last_name', e.target.value)}
                    required
                />
            </Field>

            <Field>
                <FieldLabel>{t('account:email')}</FieldLabel>
                <Input
                    type="email"
                    placeholder="marie.dubois@company.fr"
                    value={formData.email}
                    readOnly
                    className="bg-muted cursor-not-allowed"
                />
            </Field>
            <Field>
                <FieldLabel required>{t('account:role')}</FieldLabel>
                <Select value={formData.role} onValueChange={(value) => handleChange('role', value)}>
                    <SelectTrigger className="bg-card">
                        <SelectValue placeholder={t('account:selectionnerUnRole')} />
                    </SelectTrigger>
                    <SelectContent>
                        {roles
                            .filter((role) => !HIDDEN_ROLES.includes(role.name?.toLowerCase()))
                            .map((role) => (
                                <SelectItem key={role.name} value={role.name}>
                                    {getRoleLabel(role.name)}
                                </SelectItem>
                            ))}
                    </SelectContent>
                </Select>
            </Field>
        </form>
    );
}
